module.exports = __webpack_public_path__ + "img/card_hover12.b54c240e.png";